<template>
    <div>
        <div class="show-box-bg wx-login-box">
            <div class="conten">
                <div class="titl">
                    <img src="../../../assets/petition/unselected.png" alt="">
                 </div>
                 <h2>您尚未解锁本模块</h2>
                 <p>请通关后再继续参赛吧~</p>
               
                <div class="btn-box">
                    <div class="confirms" >
                        <button class="butn" @click="operser">我知道了</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['textmsg'],
        data() {
            return {
                badPorp:false
            }
        },
        mounted(){
            
        },
        methods:{
          
            operser(){
                this.$emit('porione');
            },
           
            
        }
    }
</script>

<style scoped lang="scss">
    .wx-login-box {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 901;
        .conten {
            width: 350px;
            // height: 400upx;
            background: linear-gradient(to bottom, #E5F1FF,#EFF6FE, #FAFBFF);
            z-index: 1000;
            text-align: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            border-radius: 14px;
            overflow: hidden;
            .titl {
                width: 90%;
                height: 155px;
                font-size: 17px;
                padding: 0 5%;
                color: #000000;
                text-align: center;
                img{
                    width: 124px;
                    height: 136px;
                    margin-top: 20px;
                }
                .names{
                    height: 50px;
                }
            }
           
           
            
            .btn-box {
                width: 100%;
                height: 100px;
                display: flex;
                .confirms{
                    width: 100%;
                    height: 100%;
                    text-align: center;
                    // border-right: 2rpx solid #969696;
                    .butn{
                        color: #FFFFFF;
                        width: 40%;
                        font-size: 17px;
                        height: 50px;
                        margin: 15px 0;
                        line-height: 30px;
                        border: none;
                        border-radius: 30px;
                        letter-spacing:1.5px;
                        background: linear-gradient(to left, #2D8AFF,#2DA3FF, #2DC1FF);
                    }
                }
               
               
                
            }
        }
        
    }
    
</style>